import { axios } from 'api'

export interface ProductCollectionDto {
  id: string
  name: string
  displayOrder: number
  createdAt: string
  updatedAt: string
}

export const listProductCollections = async (): Promise<
  ProductCollectionDto[]
> => {
  const response = await axios.get('/products/collections', {
    withCredentials: true
  })
  if (response.status !== 200) return []
  return response.data.collections ?? []
}

export const createProductCollection = async (
  name: string,
  displayOrder = 0
): Promise<ProductCollectionDto> => {
  const response = await axios.post(
    '/products/collections',
    { name, displayOrder },
    { withCredentials: true }
  )
  if (response.status !== 201) {
    throw new Error(response.data?.error || 'Failed to create collection')
  }
  return response.data
}

export const updateProductCollection = async (
  id: string,
  name: string,
  displayOrder: number
): Promise<ProductCollectionDto> => {
  const response = await axios.put(
    `/products/collections/${id}`,
    { name, displayOrder },
    { withCredentials: true }
  )
  if (response.status !== 200) {
    throw new Error(response.data?.error || 'Failed to update collection')
  }
  return response.data
}

export const deleteProductCollection = async (id: string): Promise<void> => {
  const response = await axios.delete(`/products/collections/${id}`, {
    withCredentials: true
  })
  if (response.status !== 204 && response.status !== 200) {
    throw new Error(response.data?.error || 'Failed to delete collection')
  }
}
